<template>
  <div class="px-page mb-8 text-center py-12">
    <div class="text-3xl font-extrabold tracking-tight sm:text-4xl">
      <span class="block">Ready to QA?</span>
      <span class="block">Scan an order to get started.</span>
      <div class="relative my-8 mx-auto max-w-xl">
        <div class="absolute inset-0 flex items-center" aria-hidden="true">
          <div class="w-full border-t border-gray-500" />
        </div>
        <div class="relative flex justify-center">
          <span class="bg-gray-200 px-4 font-semibold text-sm text-gray-500">or</span>
        </div>
      </div>
      <span class="block">Type in an order number if you must.</span>
    </div>

    <div class="mt-12 mx-auto max-w-lg">
      <label for="email" class="sr-only">Order Number</label>
      <input v-on:keyup.enter="goToOrder({ detail: order_number })" v-model="order_number" type="text" class="block w-full rounded-md border-gray-300 shadow-sm text-center focus:border-primary-500 focus:ring-primary-500 sm:text-2xl" placeholder="ORDER NUMBER" />
    </div>
  </div>

  <TransitionRoot as="template" v-bind:show="showPageLoading">
    <Dialog as="div" class="relative z-10" v-on:close="showPageLoading = false">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 z-10 overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
              <div class="bg-white p-4">
                <div class="flex items-center">
                  <div class="flex-shrink-0">
                    <ArrowPathIcon class="animate-spin h-6 w-6 text-green-600" aria-hidden="true" />
                  </div>
                  <div class="ml-3 w-0 flex-1 pt-0.5">
                    <p class="text-sm font-medium text-gray-900">Order is loading</p>
                  </div>
                  <div class="ml-4 flex flex-shrink-0">
                    <button type="button" v-on:click="showPageLoading = false" class="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none">
                      <span class="sr-only">Close</span>
                      <XMarkIcon class="h-5 w-5" aria-hidden="true" />
                    </button>
                  </div>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>
import {onMounted, onUnmounted, ref} from "vue";
import { router, usePage } from '@inertiajs/vue3';
import { useBarcodeScanner } from "../../composables/BarcodeScanner";
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from "@headlessui/vue";
import { ArrowPathIcon, XMarkIcon } from "@heroicons/vue/24/outline";

useBarcodeScanner();

const showPageLoading = ref(false);
const order_number = ref(null);

// const removePageLoadingListener = router.on('start', () => {
//   showPageLoading.value = true;
// });

// add event listener when entering page
onMounted(() => {
  document.addEventListener('scanComplete', goToOrder);
  console.log('goToOrder mounted');
});

// remove event listener when leaving page
onUnmounted(() => {
  document.removeEventListener('scanComplete', goToOrder);
  console.log('goToOrder unmounted');
});

const goToOrder = function ({ detail }) {
  showPageLoading.value = true;
  console.log(`goToOrder: ${detail}`);
  router.get(`/qa/${detail}`);
}
</script>
